import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

function UserIcon (props: IconProps) {
    return(
        <SvgIcon {...props} color="inherit" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M13.9135 4.77482C13.9135 6.93618 12.1613 8.68831 9.99999 8.68831C7.83863 8.68831 6.0865 6.93618 6.0865 4.77482C6.0865 2.61346 7.83863 0.861328 9.99999 0.861328C12.1613 0.861328 13.9135 2.61346 13.9135 4.77482ZM1.97253 15.9509C3.59233 13.7911 6.13445 12.5201 8.83412 12.5201H11.1659C13.8655 12.5201 16.4076 13.7911 18.0274 15.9509C19.3859 17.7622 18.0935 20.347 15.8294 20.347H4.17062C1.90646 20.347 0.614033 17.7622 1.97253 15.9509Z" stroke="currentColor" fill="none" strokeWidth="1.5"/>
        </SvgIcon>
    )
}

export default UserIcon;